import { render, staticRenderFns } from "./SatisfacaoForm.vue?vue&type=template&id=2c4022ec&scoped=true"
import script from "./SatisfacaoForm.vue?vue&type=script&lang=js"
export * from "./SatisfacaoForm.vue?vue&type=script&lang=js"
import style0 from "./SatisfacaoForm.vue?vue&type=style&index=0&id=2c4022ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4022ec",
  null
  
)

export default component.exports